import React from "react";
import { useLocation } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import ErrorBoundaryFallback from "./ErrorBoundaryFallback";

const RouteErrorBoundary = ({
  children,
  title,
  message,
  showReload = true,
  onReset,
  onError,
  resetOnPathChange = true,
  resetKeys = [],
}) => {
  const location = useLocation();
  const effectiveResetKeys = resetOnPathChange ? [location.pathname, ...resetKeys] : resetKeys;

  return (
    <ErrorBoundary
      resetKeys={effectiveResetKeys}
      onReset={onReset}
      onError={onError}
      fallback={({ resetErrorBoundary }) => (
        <ErrorBoundaryFallback
          title={title}
          message={message}
          onRetry={resetErrorBoundary}
          showReload={showReload}
        />
      )}
    >
      {children}
    </ErrorBoundary>
  );
};

export default RouteErrorBoundary;
